
// angular
import {
    Component,
    Output,
    EventEmitter,
    Inject,
    ViewChild,
    ViewEncapsulation,
    Input,
    AfterViewInit,
} from '@angular/core';

// Configuration
import {
    Configuration
} from '../../configurations/shared.config';

// Models
import {
    PolicyStaffObject
} from '../../dataModels/notification-tab-form';
import {
    Filtration,
    FilterCriteria,
    FilterSearchCriteria,
    Operator,
    RelationalLogicalOperator,
    SortDirection
} from '../../dataModels/grid-list';
import {
    IErrorHandler
} from '../../dataModels/contracts/IErrorHandler';

// Pipes
import {
    LocalizePipe
} from '../../pipes/Localize.pipe';
import {
    StaffFilterPipe
} from "../../pipes/staff-filter.pipe";

// Components
import {
    ListView
} from "../listView/listView/list-view.component";

// services
import {
    NotificationsTabService
} from '../../services/notification-tab-form.service';

@Component({
    moduleId: module.id,
    selector: 'notification-tab-form',
    templateUrl: './notification-tab-form.component.html',
    encapsulation: ViewEncapsulation.None,
})


export class NotificationTabComponent implements AfterViewInit {
    isEnterClicked = false;
    operationSuccessfullMessage: boolean = false;
    hasError = void 0;
    policies: any[] = [];
    policyId: number;
    policyStaffAssociationList: PolicyStaffObject[] = [];
    policyStaffList: any[] = [];
    policyStaffListFiltered: any[] = [];
    allStaffList: any;
    FilterStaffList: any[] = [];
    apiUrl: string = "";
    searchCriteria: string[] = [];
    filterCriteria: FilterCriteria = new FilterCriteria();
    editMode: boolean = false;
    showDetailsSection: boolean = false;
    isDefaultPolicy: boolean = false;
    userOperator: Operator = Operator.Contains;
    logicalOperator: RelationalLogicalOperator = RelationalLogicalOperator.Or;
    private _errorHandler: IErrorHandler;
    filterPipe: StaffFilterPipe = new StaffFilterPipe();
    private arraySearch: string[] = ['FirstName', 'LastName'];
    get _arraySearch() {
        return this.arraySearch;
    }
    public PageSize: number = 10;
    public PageNumber: number = 1;
    filtration = new Filtration();

    @ViewChild('searchList') searchList;
    @ViewChild('listView') listView: ListView;

    @Input() userIsRoot: boolean;
    @Input() subscriberId: number;

    constructor(private notificationsTabService: NotificationsTabService, @Inject("IErrorHandler") handler: IErrorHandler, private _localizer: LocalizePipe) {
        //this.filterCriteria.PageSize = 50;
        // this.filterCriteria.SearchCriteria = [];
        this._errorHandler = handler;
        if (this.userIsRoot) {
            this.apiUrl = Configuration.urls.webApiEndpoint + Configuration.urls.getUsersBySubscriber
        } else {
            this.apiUrl = Configuration.urls.webApiEndpoint + Configuration.urls.filterStaffApi
        }
    }
    ngOnInit() {

    }
    // get polict staff associations
    getPolicyStaff(pid) {
        var id = this.userIsRoot && this.userIsRoot != undefined ? this.subscriberId : pid;
        // console.log("getPolicyStaff", "pid", pid, 'this.subscriberId', this.subscriberId);
        var self = this;
        this.policyStaffList = [];
        this.policyStaffAssociationList = [];
        this.FilterStaffList = this.allStaffList.Collection;

        this.notificationsTabService.getStaffList(id).subscribe(response => {
            if (!response.IsErrorState && response.Value) {
                if (response.Value.length > 0) {
                    self.policyStaffAssociationList = response.Value;
                    this.updatePolicyStaff(response.Value.map(item => item.Staff.Id));

                    for (var elem of self.policyStaffAssociationList) {
                        elem.Staff.IsInfluencedStaff = elem.IsInfluencedStaff;
                        self.policyStaffList.push(elem.Staff);
                        self.FilterStaffList = self.FilterStaffList.filter(item => item.Id != elem.Staff.Id);
                    }

                    this.pageChanged({
                        page: 1
                    });
                }
            } else {
                this._errorHandler.Handle(this._localizer.transform(Configuration.messages.defaultErrorMessage));
            }
        },

            error => {
                this._errorHandler.Handle(this._localizer.transform(Configuration.messages.defaultErrorMessage));
            });


    }

    // save policy staff list relation
    savePolicyStaffList() {
        // console.log("savePolicyStaffList");

        var self = this;
        var final: PolicyStaffObject[] = [];
        this.policyStaffAssociationList.forEach(element => {
            var temp = new PolicyStaffObject();
            temp.Id = element.Id;
            temp.IsDeleted = element.IsDeleted;
            temp.PolicyId = element.PolicyId;
            temp.StaffId = element.StaffId;
            final.push(temp);
        });
        // console.log("savePolicyStaffList", final);

        //this._http.post(Configuration.urls.webApiEndpoint + Configuration.urls.SavePolicyStaffAssociation, final)
        this.notificationsTabService.SavePolicyStaffAssociation(final)
            .subscribe(response => {
                if (response && response.ok) {
                    var result = JSON.parse(response.text());
                    if (result.Value) {
                        self.getPolicyStaff(self.policyId);

                        if (!self.isEnterClicked) {
                            self.showSuccessMessage();
                        } else {
                            self.isEnterClicked = false;
                        }
                    } else {
                        this._errorHandler.Handle(this._localizer.transform(Configuration.messages.defaultErrorMessage));
                    }
                }
            },
                error => {
                    this._errorHandler.Handle(this._localizer.transform(Configuration.messages.defaultErrorMessage));
                });
    }

    // add staff 
    addStaff(staff) {
        // console.log("addStaff", staff);

        // to display delete button before press on save button
        staff.IsInfluencedStaff = true;
        this.policyStaffList.push(staff);
        this.pageChanged({
            page: this.PageNumber
        });
        // this.FilterStaffList = this.FilterStaffList.filter(el => el.Id != staff.Id);
        this.updatePolicyStaff(this.policyStaffList.map(function (item) {
            return item.Id;
        }));
        var associationObject = new PolicyStaffObject();
        associationObject.StaffId = staff.Id;
        associationObject.PolicyId = this.policyId;
        var index = this.policyStaffAssociationList.findIndex(item => item.StaffId == staff.Id && item.IsDeleted);
        if (index >= 0) {
            this.policyStaffAssociationList[index].IsDeleted = false;
            //  this.policyStaffAssociationList[index] = associationObject;
        } else {
            this.policyStaffAssociationList.push(associationObject); // for deletion
        }
    }

    addAll() {
        // console.log("addAll");
        this.FilterStaffList.map(staff => {
            //   this.addStaff(staffObj)
            staff.IsInfluencedStaff = true;
            this.policyStaffList.push(staff);
            var associationObject = new PolicyStaffObject();
            associationObject.StaffId = staff.Id;
            associationObject.PolicyId = this.policyId;
            var index = this.policyStaffAssociationList.findIndex(item => item.StaffId == staff.Id && item.IsDeleted);
            if (index >= 0) {
                this.policyStaffAssociationList[index].IsDeleted = false;
                //  this.policyStaffAssociationList[index] = associationObject;
            } else {
                this.policyStaffAssociationList.push(associationObject); // for deletion
            }
        })
        this.pageChanged({
            page: this.PageNumber
        });
        this.updatePolicyStaff(this.policyStaffList.map(function (item) {
            return item.Id;
        }));
    }

    // remove staff from policy staff list
    deleteStaff(staff) {
        // console.log("deleteStaff", staff);

        this.policyStaffList.splice(this.policyStaffList.indexOf(staff), 1);
        // this is the last opbject in the display list in the current page so it has to go to the page before
        if (this.policyStaffListFiltered.length == 1 && this.PageNumber != 1) {
            this.pageChanged({
                page: this.PageNumber - 1
            })
        } else {
            this.pageChanged({
                page: this.PageNumber
            });
        }
        // this.FilterStaffList.push(staff);
        this.updatePolicyStaff(this.policyStaffList.map(function (item) {
            return item.Id;
        }));
        var associationObject = new PolicyStaffObject();
        associationObject.StaffId = staff.Id;
        associationObject.PolicyId = this.policyId;
        var index = this.policyStaffAssociationList.findIndex(x => x.StaffId == associationObject.StaffId &&
            x.PolicyId == associationObject.PolicyId);
        if (index >= 0) {
            this.policyStaffAssociationList[index].IsDeleted = true;
        } else {
            associationObject.IsDeleted = true;
            this.policyStaffAssociationList.push(associationObject); // for deletion
        }
    }

    deleteAll() {
        // console.log("deleteAll");

        this.policyStaffListFiltered.map(staff => {
            this.policyStaffList.splice(this.policyStaffList.indexOf(staff), 1);
            var associationObject = new PolicyStaffObject();
            associationObject.StaffId = staff.Id;
            associationObject.PolicyId = this.policyId;
            var index = this.policyStaffAssociationList.findIndex(x => x.StaffId == associationObject.StaffId &&
                x.PolicyId == associationObject.PolicyId);
            if (index >= 0) {
                this.policyStaffAssociationList[index].IsDeleted = true;
            } else {
                associationObject.IsDeleted = true;
                this.policyStaffAssociationList.push(associationObject); // for deletion
            }
        })

        this.PageNumber == 1 ? this.pageChanged({
            page: this.PageNumber
        }) : this.pageChanged({
            page: this.PageNumber - 1
        });

        this.updatePolicyStaff(this.policyStaffList.map(function (item) {
            return item.Id;
        }));
    }

    // setPolicy Id and call get users
    SetPolicyId(pid) {
        // console.log("SetPolicyId", pid);

        this.policyId = pid;
        this.getPolicyStaff(this.policyId);
        this.showDetailsSection = true;
    }

    updatePolicyStaff(Ids: any[]) {
        // console.log("updatePolicyStaff", Ids);

        this.listView.filter.SearchCriteria = [];
        for (var elem of Ids) {
            this.listView.filter.SearchCriteria.push(new FilterSearchCriteria("Id", Operator.NotEqual, elem, RelationalLogicalOperator.And));
        }
        this.listView.Refresh(false);
    }

    PageChanged(collection) {
        // if (this.userIsRoot) {
        //     console.log("PageChanged", "this.userIsRoot", this.userIsRoot);
        //     this.notificationsTabService.getUsersBySubscriber(this.filtration).subscribe(response => {
        //         if (!response.IsErrorState && response.Value) {
        //             console.log(`response.Value.Collection`);
        //             console.log(response.Value.Collection);
        //             this.allStaffList = response.Value;
        //             this.FilterStaffList = response.Value.Collection;
        //             console.log("this.FilterStaffList", this.FilterStaffList);

        //             // for (var elem of this.policyStaffList)
        //             //     this.FilterStaffList = this.FilterStaffList.filter(item => item.Id != elem.Id);
        //         } else {
        //             this._errorHandler.Handle(this._localizer.transform(Configuration.messages.defaultErrorMessage));
        //         }
        //     });

        // } else {
        // console.log("PageChanged", "collection", collection);

        this.allStaffList = collection;
        this.FilterStaffList = this.allStaffList.Collection;
        // console.log("this.allStaffList", this.allStaffList);
        // console.log("this.FilterStaffList", this.FilterStaffList);

        for (var elem of this.policyStaffList)
            this.FilterStaffList = this.FilterStaffList.filter(item => item.Id != elem.Id);
        //this.updatePolicyStaff(this.policyStaffList);
        // }

    }

    pageChanged(event) {
        // console.log("pageChanged", "event", event);

        this.PageNumber = event.page;
        // setting timeout because of expression changed error in console
        setTimeout(() =>
            this.policyStaffListFiltered = [...this.policyStaffList.slice((this.PageNumber - 1) * this.PageSize, (this.PageNumber - 1) * this.PageSize + this.PageSize)], 0);
    }

    resetUsersLists() {
        // console.log("resetUsersLists");

        this.FilterStaffList = this.allStaffList.Collection;
        this.policyStaffList = this.policyStaffAssociationList = [];
    }

    ngAfterViewInit() {
        //this.getAllStaffList();
        // console.log("userIsRoot", this.userIsRoot);
        // console.log("subscriberId", this.subscriberId);
        if (this.userIsRoot) {
            this.filtration = {
                PageCriteria: {
                    PageNumber: -1,
                    PageSize: 10
                },
                SearchCriteria: [{
                    "Field": "SubscriberId",
                    "Operator": 0,
                    "SearchKey": this.subscriberId ? this.subscriberId.toString() : ""

                }],
                SortCriteria: {
                    Direction: SortDirection.ASC,
                    Field: "StaffName"
                }
            }
        }



    }

    onKeyPress(searchCriteria) {
        //  this.FilterStaffList =
        //   this.filterPipe.transform(this.allStaffList, searchCriteria);
    }

    keyDownFunction(event) {
        // console.log("keyDownFunction", event);
        if (event.keyCode === 13) {
            this.isEnterClicked = true;
        }
    }

    private successMessageTimeout;
    private showSuccessMessage() {
        // console.log("showSuccessMessage");
        this.operationSuccessfullMessage = true;
        // clear the old Timeout (if exists)
        clearTimeout(this.successMessageTimeout);
        // start a new Timeout
        this.successMessageTimeout = setTimeout(() => this.operationSuccessfullMessage = false, 3000);
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/notificationTabForm/notification-tab-form.component.ts